var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, Unique, UpdateDateColumn } from 'typeorm';
let Stream = class Stream {
    id;
    address;
    groupId;
    groupIndex;
    coinType;
    balance;
    objectVersion;
    creator;
    recipient;
    timeStart;
    cliff;
    epochInterval;
    totalEpoch;
    amountPerEpoch;
    cancelable;
    autoClaimEnabled;
    rawData;
    status;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Stream.prototype, "id", void 0);
__decorate([
    Column(),
    Index({ unique: true }),
    __metadata("design:type", String)
], Stream.prototype, "address", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], Stream.prototype, "groupId", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Stream.prototype, "groupIndex", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], Stream.prototype, "coinType", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], Stream.prototype, "balance", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], Stream.prototype, "objectVersion", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], Stream.prototype, "creator", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], Stream.prototype, "recipient", void 0);
__decorate([
    Column(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], Stream.prototype, "timeStart", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], Stream.prototype, "cliff", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], Stream.prototype, "epochInterval", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], Stream.prototype, "totalEpoch", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], Stream.prototype, "amountPerEpoch", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], Stream.prototype, "cancelable", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Boolean)
], Stream.prototype, "autoClaimEnabled", void 0);
__decorate([
    Column('text'),
    __metadata("design:type", String)
], Stream.prototype, "rawData", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Stream.prototype, "status", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Stream.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Stream.prototype, "createdAt", void 0);
Stream = __decorate([
    Entity({ name: 'stream' }),
    Unique(['groupId', 'groupIndex'])
], Stream);
export { Stream };
//# sourceMappingURL=module.js.map